import React, { useEffect } from 'react';
import { oneOf } from 'prop-types';
import { extend } from '@thd-nucleus/data-sources';
import { Clock } from '@one-thd/sui-icons';
import { Typography } from '@one-thd/sui-atomic-components';
import { EmailSignupForm } from './subcomponents/EmailSignupForm';
import { PROMO_TYPES } from '../constants';

export const PromotionsEmailSignup = ({ promotionType }) => {

  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('promotions-email-signup.ready');
  }, []);

  return (
    <div className="sui-flex sui-justify-between sui-pt-2 sui-pb-2">
      <div className="sui-flex sui-mt-2 sui-pr-4">
        <Clock className="sui-align-center sui-fill-brand sui-h-8 sui-inline-block sui-mr-3" />
        <div className="sui-mt-1">
          <Typography>
            <span className=" sui-text-lg">
              <span className="sui-font-bold">Be the First to Know.&ensp;</span>
              Join our specials mailing list
            </span>
          </Typography>
        </div>
      </div>
      <EmailSignupForm promotionType={promotionType} />
    </div>
  );
};

PromotionsEmailSignup.propTypes = {
  /**
   * To identify which type of email to signup for
   */
  promotionType: oneOf(PROMO_TYPES).isRequired
};

PromotionsEmailSignup.displayName = 'PromotionsEmailSignup';

PromotionsEmailSignup.dataModel = extend(EmailSignupForm);
